import React from 'react';

// Custom V Currency Symbol with neon green line
export const CurrencySymbol = ({ className = "", size = "md" }) => {
    const sizes = {
        sm: { width: 12, height: 14, strokeWidth: 2 },
        md: { width: 16, height: 18, strokeWidth: 2.5 },
        lg: { width: 24, height: 28, strokeWidth: 3 },
        xl: { width: 32, height: 36, strokeWidth: 3.5 }
    };

    const { width, height, strokeWidth } = sizes[size] || sizes.md;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`inline-block ${className}`}
        >
            {/* V shape */}
            <path
                d="M2 4L12 24L22 4"
                stroke="currentColor"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Horizontal strike-through lines with neon green */}
            <line
                x1="5"
                y1="10"
                x2="19"
                y2="10"
                stroke="#39FF14"
                strokeWidth={strokeWidth * 0.8}
                strokeLinecap="round"
                style={{
                    filter: "drop-shadow(0 0 4px #39FF14) drop-shadow(0 0 8px #39FF14)"
                }}
            />
            <line
                x1="7"
                y1="14"
                x2="17"
                y2="14"
                stroke="#39FF14"
                strokeWidth={strokeWidth * 0.8}
                strokeLinecap="round"
                style={{
                    filter: "drop-shadow(0 0 4px #39FF14) drop-shadow(0 0 8px #39FF14)"
                }}
            />
        </svg>
    );
};

// Currency display component
export const CurrencyDisplay = ({ amount, size = "md", showSymbol = true, className = "" }) => {
    const textSizes = {
        sm: "text-sm",
        md: "text-base",
        lg: "text-2xl",
        xl: "text-4xl"
    };

    return (
        <span className={`inline-flex items-center gap-1 font-mono font-semibold ${textSizes[size]} ${className}`}>
            {showSymbol && <CurrencySymbol size={size} />}
            <span>{Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </span>
    );
};

export default CurrencySymbol;
